export default {
    //发送验证码
    sendVerificationCode: "client/member/skipAuth/multiclass/sendMsg",
    //获取省份数据
    getProvinceList: "client/lbs/provinceList/client",
    //获取城市 || 区域
    getDistrictList: "client/lbs/getAreaByCode/client",
    //获取优势快递列表
    getExpressList: "client/logistics/shop/optimal/shipper",
    //获取七牛云token
    getQiniuToken: "client/file/getToken",
    //获取店铺信息
    getStoreInfo: "client/offline/store/skipAuth/queryDistributionCentreMsg",
    //获取二维码
    getQrCode: "client/member/skipAuth/download/QRcode",
    //查找公司名称列表
    queryCompanyNameList: "client/invoice/fuzzy/query",
    //查找公司信息
    queryCompanyInfo: "client/invoice/query/company/info",
};
